import { matchPath } from "react-router-dom";

export function isCurrentPath(pathname: string, path?: string ): boolean {
  return path
    ? !!matchPath({ path, end: false }, pathname)
    : false;
}